module.exports = "pegasus/assets/hexline-google.png";